import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Calendar } from "lucide-react";

const CommonDatePicker = ({
  value,
  onChange,
  placeholder = "mm/dd/yyyy",
  dateFormat = "yyyy-MM-dd",
  buttonClassName = "",
  disabled = false,
}) => {
  return (
    <DatePicker
      selected={value}
      onChange={onChange}
      dateFormat={dateFormat}
      disabled={disabled}
      customInput={
        <button
          type="button"
          disabled={disabled}
          className={`btn-border-grey form-control vehicle-form-input bg-white rounded-3 px-3 py-2 d-flex justify-content-between align-items-center gap-2 ${buttonClassName}`}
          style={{ height: "36px", color: "#8790A1" }}
        >
          {value ? (
            value.toLocaleDateString()
          ) : (
            <span style={{ color: "#8790A1" }}>{placeholder}</span>
          )}
          <Calendar size={16} />
        </button>
      }
    />
  );
};

export default CommonDatePicker;
